import { useState } from 'react'
import { TICKET_TYPE_TREE } from '../../utils/ticketType'

/**
 * Guía de tipos de registro. Espeja la selección en dos niveles del formulario:
 * primero la familia (Soporte / Desarrollo) y luego los tipos que contiene, cada
 * uno desplegable con ejemplos reales.
 *
 * Se alimenta de `TICKET_TYPE_TREE`, así que siempre refleja las mismas opciones
 * que ofrece el formulario. Está pensada para renderizarse dentro de
 * `TicketHelpPanel`, que aporta los estilos compartidos `.hg-*`.
 *
 * @component
 * @returns {JSX.Element}
 */
const TicketTypeGuide = () => {
  const [group, setGroup] = useState(TICKET_TYPE_TREE[0].value)
  /** Tipo expandido; sólo uno abierto a la vez para no alargar la barra lateral. */
  const [openType, setOpenType] = useState(null)

  const activeGroup =
    TICKET_TYPE_TREE.find((g) => g.value === group) || TICKET_TYPE_TREE[0]

  const toggle = (value) =>
    setOpenType((prev) => (prev === value ? null : value))

  return (
    <div className="ttg">
      <p className="hg-intro">
        Elegir bien el tipo hace que su caso llegue al equipo correcto. Toque
        una opción para ver <strong>ejemplos</strong>.
      </p>

      <div className="hg-seg">
        {TICKET_TYPE_TREE.map((g) => {
          const active = g.value === group
          return (
            <button
              key={g.value}
              type="button"
              className={`hg-seg-btn ${active ? 'is-active' : ''}`}
              onClick={() => setGroup(g.value)}
              style={
                active
                  ? {
                      color: g.color,
                      borderColor: g.color,
                      background: `${g.color}14`,
                    }
                  : undefined
              }
            >
              <i className={`fa-solid ${g.icon}`} />
              {g.label}
            </button>
          )
        })}
      </div>

      <p className="ttg-group-hint">{activeGroup.hint}</p>

      <div className="hg-rows">
        {activeGroup.types.map((type) => {
          const isOpen = openType === type.value
          return (
            <div
              key={type.value}
              className="hg-row"
              style={
                isOpen
                  ? {
                      borderColor: `${type.color}66`,
                      background: `${type.color}0d`,
                    }
                  : undefined
              }
            >
              <button
                type="button"
                className="hg-row-btn"
                onClick={() => toggle(type.value)}
                aria-expanded={isOpen}
              >
                <span
                  className="hg-row-icon"
                  style={{ color: type.color, background: `${type.color}1f` }}
                >
                  <i className={`fa-solid ${type.icon}`} />
                </span>
                <span className="hg-row-texts">
                  <span className="hg-row-label">{type.label}</span>
                  <span className="hg-row-hint">{type.hint}</span>
                </span>
                <i
                  className={`fa-solid fa-chevron-down hg-chevron ${
                    isOpen ? 'is-open' : ''
                  }`}
                />
              </button>

              {isOpen && (
                <ul className="hg-examples">
                  {type.examples.map((example) => (
                    <li key={example}>{example}</li>
                  ))}
                </ul>
              )}
            </div>
          )
        })}
      </div>

      <style>{`
        .ttg-group-hint {
          margin: -6px 0 10px;
          font-size: 0.72rem;
          line-height: 1.35;
          color: var(--gm-text-faint);
        }
      `}</style>
    </div>
  )
}

export default TicketTypeGuide
